'use strict';

app.controller('ApplicationSettingCtrl', [
    '$scope',
    '$http',
    '$translate',
    'toaster',
    '$ngConfirm',
    '$timeout',
    function($scope, $http, $translate, toaster, $ngConfirm, $timeout) {
        $scope.CLIENT_TAB = 1;
        $scope.LOGIN_TAB = 2;
        $scope.APP_TAB = 3;

        $scope.loading = false;

        $scope.applicationLoginSettingsFull = [];
        $scope.applicationLoginSettingsLength = 0;

        $scope.applicationClientSettingsFull = [];
        $scope.applicationClientSettingsLength = 0;

        $scope.users = [];

        $scope.pagination = {
            currentPage: 1,
            maxSize: 10,
            numPerPage: 30,
        };

        $scope.json = '';

        $scope.form = {
            code: '',
            user: '',
            login_client: '',
            cache: '',
            pattern: '',
        };

        $scope.CACHE_TYPE = [
            {
                id: 2,
                pattern: '*login-features*',
            },
            {
                id: 3,
                pattern: '*login-groups*',
            },
            {
                id: 4,
                pattern: '*group-objects*',
            },
            {
                id: 5,
                pattern: '*hybrid-selector*',
            },
        ];

        $scope.pageChanged = function() {
            var begin = ($scope.pagination.currentPage - 1) * $scope.pagination.numPerPage;
            var end = begin + $scope.pagination.numPerPage;

            if ($scope.isTab($scope.CLIENT_TAB)) {
                $scope.applicationClientSettingsFiltered = $scope.applicationClientSettings.slice(begin, end);
            } else {
                $scope.applicationLoginSettingsFiltered = $scope.applicationLoginSettings.slice(begin, end);
            }
        };

        $scope.afterSorting = function(sortingSettings) {
            if ($scope.isTab($scope.CLIENT_TAB)) {
                $scope.applicationClientSettings = sortingSettings;
            } else {
                $scope.applicationLoginSettings = sortingSettings;
            }

            $scope.pageChanged();
        };

        $scope.buildUpdatePayload = function(applicationSetting) {
            var payload = {
                loginId: applicationSetting.loginId,
                clientId: applicationSetting.cleintId,
                isShowedAddressAsBeam: applicationSetting.isShowedAddressAsBeam,
            };

            return payload;
        };

        $scope.updateOne = function(applicationSetting) {
            applicationSetting.isShowedAddressAsBeam = !applicationSetting.isShowedAddressAsBeam;
            var payload = $scope.buildUpdatePayload(applicationSetting);

            update({ applicationSettings: [payload] });
        };

        $scope.updateShowTrafficOnMaps = function(applicationSetting) {
            applicationSetting.isShowTrafficOnMaps = !applicationSetting.isShowTrafficOnMaps;

            var payload = {
                clientId: applicationSetting.clientId,
                isShowTrafficOnMaps: applicationSetting.isShowTrafficOnMaps,
            };

            $http.post('/api/applicationSetting/client/update', { applicationSettings: [payload] }).then(
                function() {
                    toaster.pop({
                        type: 'success',
                        title: $translate.instant('general.toastr.success.header'),
                        body: $translate.instant('general.toastr.success.form.action.update'),
                    });
                },
                function() {
                    toaster.pop({
                        type: 'error',
                        title: $translate.instant('general.toastr.error.header'),
                        body: $translate.instant('general.toastr.error.form.action.update'),
                    });
                }
            );
        };

        $scope.updateMany = function(isShowedAsBeam) {
            $scope.applicationLoginSettings.forEach(function(elem) {
                elem.isShowedAddressAsBeam = isShowedAsBeam;
            });

            update({
                applicationSettings: $scope.applicationLoginSettings,
            });
        };

        var update = function(param) {
            $http.post('/api/applicationSetting/update', param).then(
                function() {
                    toaster.pop({
                        type: 'success',
                        title: $translate.instant('general.toastr.success.header'),
                        body: $translate.instant('general.toastr.success.form.action.update'),
                    });
                },
                function() {
                    toaster.pop({
                        type: 'error',
                        title: $translate.instant('general.toastr.error.header'),
                        body: $translate.instant('general.toastr.error.form.action.update'),
                    });
                }
            );
            return true;
        };

        $scope.list = function() {
            $scope.loading = true;
            $scope.worktimeSettings = [];

            $http.get('/api/applicationSetting/list').then(
                function(response) {
                    var applicationSettings = (response.data.data || {}).applicationSettings;
                    $scope.applicationLoginSettingsFull = applicationSettings !== void 0 ? applicationSettings : [];
                    $scope.applicationLoginSettingsLength = Object.keys(applicationSettings).length;
                    $scope.applicationLoginSettings = $scope.applicationLoginSettingsFull;
                    $scope.applicationLoginSettingsLength =
                        ($scope.applicationLoginSettings.length * $scope.pagination.maxSize) /
                        $scope.pagination.numPerPage;

                    $scope.loading = false;
                    $scope.pageChanged();
                },
                function() {
                    $scope.loading = false;
                }
            );
        };

        $scope.searchByClient = function() {
            $scope.applicationClientSettings = $scope.applicationClientSettingsFull.filter(function(elem) {
                return elem.code.includes($scope.form.code);
            });

            $scope.applicationClientSettingsLength =
                ($scope.applicationClientSettings.length * $scope.pagination.maxSize) / $scope.pagination.numPerPage;
            $scope.pagination.currentPage = 1;
            $scope.pageChanged();
        };

        $scope.searchByLogin = function() {
            $scope.applicationLoginSettings = $scope.applicationLoginSettingsFull.filter(function(elem) {
                if ($scope.form.user && $scope.form.login_client) {
                    return elem.user.includes($scope.form.user) && elem.code.includes($scope.form.login_client);
                }

                if ($scope.form.user) {
                    return elem.user.includes($scope.form.user);
                }

                return elem.code.includes($scope.form.login_client);
            });

            $scope.applicationLoginSettingsLength =
                ($scope.applicationLoginSettings.length * $scope.pagination.maxSize) / $scope.pagination.numPerPage;

            $scope.pagination.currentPage = 1;
            $scope.pageChanged();
        };

        $scope.client_list = function() {
            $scope.loading = true;
            $scope.worktimeSettings = [];

            $http.get('/api/applicationSetting/client/list').then(
                function(response) {
                    var applicationSettings = (response.data.data || {}).applicationSettings;
                    $scope.applicationClientSettingsFull = applicationSettings !== void 0 ? applicationSettings : [];
                    $scope.applicationClientSettings = $scope.applicationClientSettingsFull;
                    $scope.applicationClientSettingsLength =
                        ($scope.applicationClientSettings.length * $scope.pagination.maxSize) /
                        $scope.pagination.numPerPage;

                    $scope.loading = false;
                    $scope.pageChanged();
                },
                function() {
                    $scope.loading = false;
                }
            );
        };

        $scope.toggleExpandedForm = function() {
            $scope.expanded = !$scope.expanded;
        };

        $scope.isExpandedForm = function() {
            return $scope.expanded === true;
        };

        $scope.init = function() {
            $scope.tab = $scope.APP_TAB;
            $scope.expanded = false;
        };

        $scope.changeTab = function(v) {
            $scope.tab = v;
            $scope.pagination.currentPage = 1;

            if (v === $scope.CLIENT_TAB) {
                $scope.client_list();
            }

            if (v === $scope.LOGIN_TAB) {
                $scope.list();
            }
        };

        $scope.isTab = function(tab) {
            return $scope.tab === tab;
        };

        $scope.showCache = function(key) {
            key = key.replaceAll('*', '');
            $scope.form.pattern = key;

            $http
                .get('/rest-api/redis/get', {
                    params: {
                        key: key,
                    },
                })
                .then(
                    function(response) {
                        $scope.json = JSON.stringify(response.data, null, 4);
                    },
                    function() {
                        toaster.pop({
                            type: 'error',
                            title: $translate.instant('general.toastr.error.header'),
                            body: $translate.instant('application_setting.general.cache.toastr.error.show'),
                        });
                    }
                );
        };

        $scope.removeCache = function(pattern, sanitize) {
            if (!$scope.form.cache && !sanitize) {
                toaster.pop({
                    type: 'error',
                    title: $translate.instant('general.toastr.error.header'),
                    body: $translate.instant('application_setting.general.cache.toastr.error.empty'),
                });

                return;
            }

            if (sanitize) {
                pattern = pattern.replaceAll('*', '');
                $scope.form.pattern = pattern;
            }

            var params = {
                types: ['pattern'],
                pattern: pattern,
            };

            $scope.openConfirmRemoveCacheModal(params);
        };

        $scope.openConfirmRemoveCacheModal = function(params) {
            $ngConfirm({
                title: $translate.instant('application_setting.general.cache.model.title'),
                content: $translate.instant('application_setting.general.cache.model.content'),
                animation: 'rotate',
                theme: 'supervan',
                columnClass: 'medium',
                icon: 'pe-7s-trash pe-lg pe-va',
                scope: $scope,
                buttons: {
                    yes: {
                        text: $translate.instant('general.confirm.ok'),
                        btnClass: 'btn-success',
                        action: function() {
                            $http
                                .get('/api/node/redis/clear', {
                                    params,
                                })
                                .then(
                                    function() {
                                        $scope.json = '';

                                        toaster.pop({
                                            type: 'success',
                                            title: $translate.instant('general.toastr.success.header'),
                                            body: $translate.instant(
                                                'application_setting.general.cache.toastr.success.remove'
                                            ),
                                        });
                                    },
                                    function() {
                                        toaster.pop({
                                            type: 'error',
                                            title: $translate.instant('general.toastr.error.header'),
                                            body: $translate.instant(
                                                'application_setting.general.cache.toastr.error.remove'
                                            ),
                                        });
                                    }
                                );
                        },
                    },
                    no: {
                        text: $translate.instant('general.confirm.save.cancel'),
                        btnClass: 'btn-dark',
                    },
                },
            });
        };

        $scope.init();
    },
]);
